export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'How will I receive the material?',
    answer:
      "Immediately after payment, you'll receive access instructions to download and use PROSTHO 360™ and all included bonuses.",
  },
  {
    question: 'Can I use it on my phone?',
    answer: 'Yes. The materials are designed to be easy to access from your phone, tablet, or computer.',
  },
  {
    question: 'Is everything in English?',
    answer: 'Yes. All core PROSTHO 360™ materials are provided in English.',
  },
  {
    question: 'Who is PROSTHO 360™ for?',
    answer:
      'It is primarily designed for dental students who want a more organized way to understand and review Prosthodontics.',
  },
  {
    question: 'Do I need to be a Prosthodontics specialist?',
    answer:
      'No. The system is designed for students who need to organize and review foundational and clinically relevant Prosthodontics concepts.',
  },
  {
    question: 'Does PROSTHO 360™ replace my lectures or textbooks?',
    answer:
      "No. PROSTHO 360™ is a supplementary study and review tool. It is not intended to replace your dental school's curriculum, required textbooks, lectures, or guidance from your instructors.",
  },
  {
    question: 'Are the materials downloadable?',
    answer: "Yes. You'll receive digital materials that you can access and download after purchase.",
  },
  {
    question: 'Is this a one-time payment?',
    answer: 'Yes. You pay $27 once and receive lifetime access to the purchased materials.',
  },
  {
    question: "What if I don't like it?",
    answer:
      "You're covered by our 7-Day Money-Back Guarantee. Review the materials and decide whether they're right for you. If not, request a refund within the guarantee period.",
  },
]
